// extracted by mini-css-extract-plugin
export default {"title":"index_title_eOEPh"};